import { render, staticRenderFns } from "./Arbitros.vue?vue&type=template&id=667f5947&"
import script from "./Arbitros.vue?vue&type=script&lang=js&"
export * from "./Arbitros.vue?vue&type=script&lang=js&"
import style0 from "./Arbitros.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports